import { createListenerMiddleware } from "@reduxjs/toolkit";
import { setLogout, setLogoutPending } from "features/authSlice";
import { afterLogoutApi } from "pages/login/afterLogoutService";
import { logOutApi } from "pages/login/logoutService";
import { dashboardLogoutApi } from "pages/dashboard/home/dashboardLogoutService";
import { clearLoanOfficerDetail } from "services/common/loanOfficerSlice";
import { deleteAllFiles } from "utilities/files";
import * as Constant from "utilities/Constant";
import { RootState } from "store";

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: setLogoutPending,
  effect: async (_, listenerApi) => {
    listenerApi.unsubscribe();

    const state = listenerApi.getState() as RootState;
    const userId = state.auth.userId;
    const dashboardSessionId = sessionStorage.getItem(Constant.DASHBOARD_SESSION_ID);

    await listenerApi.delay(1500);

    try { await deleteAllFiles(); } catch { /* best effort */ }

    try {
      if (userId) {
        await listenerApi.dispatch(logOutApi.endpoints.postSessionInactvityLogout.initiate(userId));
      }
    } catch { /* best effort */ }

    try {
      if (userId && dashboardSessionId) {
        await listenerApi
          .dispatch(
            dashboardLogoutApi.endpoints.updateDashboardSessionEnd.initiate({
              userId: userId,
              dashboardSession: {
                dashboardSessionId: dashboardSessionId,
                dashboardSessionStartTimestamp: sessionStorage.getItem(Constant.DASHBOARD_SESSION_START_TIMESTAMP),
                dashboardSessionEndTimestamp: new Date().toISOString(),
              },
            })
          )
          .unwrap();
      }
    } catch { /* best effort */ }

    try {
      await listenerApi.dispatch(afterLogoutApi.endpoints.postAfterLogout.initiate());
    } catch { /* best effort */ }

    listenerApi.dispatch(clearLoanOfficerDetail());
    sessionStorage.clear();
    listenerApi.dispatch(setLogout());

    listenerApi.subscribe();
  },
});

listenerMiddleware.startListening({
  actionCreator: setLogout,
  effect: async (_, listenerApi) => {
    listenerApi.dispatch(clearLoanOfficerDetail());
    try {
      await listenerApi.dispatch(afterLogoutApi.endpoints.postAfterLogout.initiate());
    } catch { /* best effort */ }
  },
});
